<template>
    <div data-name="for-admins">
        <div class="admin-header">
            <p>ADMIN PANEL</p>
        </div>
        <router-link :to="{name: 'admin-requests'}">
            <div
                :class="{'active-item': $route.name === 'admin-requests'}" 
                data-name="admin-item">
                    <p>
                        Requests Panel
                    </p>
            </div>
        </router-link>
        <router-link :to="{name: 'admin-campaigns'}">
            <div
                :class="{'active-item': $route.name === 'admin-campaigns'}" 
                data-name="admin-item">
                    <p>
                        Campaigns Panel
                    </p>
            </div>
        </router-link>
        <router-link :to="{name: 'admin-drafts'}">
            <div
                :class="{'active-item': $route.name === 'admin-drafts'}" 
                data-name="admin-item">
                    <p>
                        Drafts Panel
                    </p>
            </div>
        </router-link>
        <router-link :to="{name: 'admin-archives'}">
            <div
                :class="{'active-item': $route.name === 'admin-archives'}" 
                data-name="admin-item">
                    <p>
                        Archives Panel
                    </p>
            </div>
        </router-link>
        <router-link :to="{name: 'admin-referrals'}">
            <div
                :class="{'active-item': $route.name === 'admin-referrals'}" 
                data-name="admin-item">
                    <p>
                        Referrals Panel
                    </p>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'AdminSection'
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables.scss';
div[data-name="for-admins"] {
    div.admin-header {
        background: #e3e5fd80;
        p {
            font-size: $p4;
            font-weight: $weight_bold;
            color: $c7;
            text-align: center;
        }
    }
    div[data-name="admin-item"] {
        height: 60px;
        padding-left: 24px;
        display: flex;
        align-items: center;
        transition: all 0.3s ease;

        &.active-item  {
            background: #e3e5fd80;
            border-top: 2px solid $c14;
        }
        &:hover {
            background: #e3e5fd80
        }
        p {
            color: $c1;
            font-size: $p4;
            font-weight: $weight_bold;
        }
    }
}
</style>